export const InstagramArticleEmbed : React.FC<InstagramEmbedProps> = ({src}) => {
    return(
        <iframe
            className='instagram-media instagram-media-rendered instagram-iframe'
            src={`https://www.instagram.com/p/${src}/embed`}>
        </iframe>
    )
}